import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { AppMedia, AppLink } from './'
import state from '../store/store';

interface SectionAssociationsCTA {
    __component: string;
    data?: any;
}

export const SectionAssociationsCTA: FunctionalComponent<SectionAssociationsCTA> = ({ data }) => {


    const { Title, brands, RemoveTopMargin, Description } = data;
    const useDefault = isEmpty(get(brands, 'data'))
    const DefaultBrands = get(state.website, 'DefaultBrands.brands.data') || [];
    const BrandCards = (useDefault ? DefaultBrands : (get(brands, 'data') || [])).map(({ attributes }) => attributes);
    const howardsonLink = { 'URL': 'https://howardsongroup.com', Alt: 'Howardson Group' }


    return (
        <section class={`uk-section ${RemoveTopMargin ? 'uk-padding-remove-top' : ''}`}>
            <div class="uk-container">
                <div hidden={!Title} class="uk-text-center uk-margin-small-top">
                    <h2 class="uk-heading-small uk-text-primary uk-text-bold uk-margin-small-bottom">{Title}</h2>
                    <hr class="uk-divder-slashed uk-width-1-2 uk-width-1-4@m uk-width-1-5@l uk-margin-medium-bottom@s" />
                </div>
                <div hidden={!useDefault}>
                    <div class="uk-width-1-1 uk-text-center">
                        <AppLink className='uk-margin-bottom uk-button uk-button-link' data={howardsonLink}>
                            <img class="uk-preserve uk-width-large uk-position-z-index" src="/assets/images/howardson.svg" aria-label="Howardson Group Logo" alt="Howardson Group Logo" uk-svg></img>
                        </AppLink>
                    </div>
                    <div class="uk-width-1-1 uk-margin-medium-top">
                            {/* TODO: make responsive */}
                            <div class="uk-flex uk-flex-center uk-flex-wrap uk-flex-wrap-around uk-flex-wrap-middle">
                    {
                        BrandCards.map(({ Link, Logo }) => {
                            return [
                                            <div class="uk-width-1-4 uk-padding-small uk-padding-remove-top uk-padding-remove-bottom uk-flex uk-flex-top uk-flex-center">
                                    <div class="">
                                        <AppLink className='uk-button uk-button-link uk-animation-toggle' data={Link}>
                                                        <AppMedia className='' size="(max-width: 638px) 50vw, (max-width: 958px) 30vw, 20vw" media={Logo} />
                                        </AppLink>
                                    </div>
                                </div>
                            ]
                        })
                    }
                </div>
            </div>
                    <p hidden={!Description} class='uk-text-center uk-text-small uk-text-muted'>{Description}</p>
                </div>
            </div>
        </section >
    )
};